import { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import PageLayout from "../components/PageLayout";
import SurveyCard from "../components/SurveyCard";

import styles from "./pages.module.css";

import { getSurveys } from "../utils/APIConnector";

export default function Surveys() {
    const { i18n, t } = useTranslation();
    const [surveys, setSurveys] = useState([]);
    const [error, setError] = useState(false);

    useEffect(() => {
        getSurveys()
            .then((data) => {
                setSurveys(data);
            })
            .catch((err) => {
                setError(true);
            });
    }, []);


    return (
        <PageLayout>
            <section className={styles.invitationSection}>
                <h2 className={styles.title}>{t("home.inviteTitle")}</h2>
                <p className={styles.text}>{t("home.inviteText1")}</p>
            </section>
            <section className={styles.section}>
                {error ? (
                    <p style={{ color: "var(--color-text-error)" }}>
                        {t("surveys.loadError")}
                    </p>
                ) : (
                    <div
                        role="list"
                        className="survey-list"
                    >
                        {surveys.map((survey) => {
                            const id = survey.surveyID;
                            return (
                                <Link
                                    key={id}
                                    to={`/surveys/${id}`}
                                    role="listitem"
                                    className={styles.surveyLink}
                                    onClick={(e) => {
                                        if (!survey.status) {
                                            e.preventDefault();
                                        }
                                    }}
                                    aria-disabled={!survey.status}
                                >
                                    <SurveyCard survey={survey} lang={i18n.language} />
                                </Link>
                            );
                        })}
                    </div>

                )}
            </section>
        </PageLayout>
    );
}
